// localStorage keys
export const CLIENT_INSTANCE_ID_KEY = 'boomtown-client-instance-id';
